import React from "react";

/**
 * Large, high-visibility number badge shown before each meal/soup image.
 * Global numbering: index is 1-based (1, 2, 3... across pages).
 * When unavailable, the number is crossed out with a diagonal line.
 */
function MealNumberBadge({ index, unavailable, classNamePrefix = "daily-menu-screen" }) {
  const n = Number(index);
  if (n < 1 || !Number.isFinite(n)) return null;

  const prefix = classNamePrefix || "daily-menu-screen";
  const className = [
    `${prefix}__meal-badge`,
    unavailable ? `${prefix}__meal-badge--unavailable` : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={className} aria-hidden="true">
      {n}
    </div>
  );
}

export default MealNumberBadge;
